import { addToListModalStyles } from "@insite/content-library/Components/AddToListModal";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
import { css } from "styled-components";

addToListModalStyles.modal = {
    size: 350,
    cssOverrides: {
        modalBody: css`
            overflow-y: visible;
        `,
        modalTitle: css`
            padding: 10px 20px;
            color: ${getColor("text.main")};
        `,
        modalContent: css`
            padding: 20px;
        `,
    },
};
addToListModalStyles.descriptionText = {
    as: "p",
    css: css`
        color: ${getColor("text.main")};
    `,
};
addToListModalStyles.listsSelect = {
    cssOverrides: {
        formField: css`
            margin-top: 15px;
            label {
                color: ${getColor("text.main")};
            }
        `,

        list: css`
            max-height: 300px;
            ::-webkit-scrollbar {
                width: 5px;
            }

            ::-webkit-scrollbar-thumb {
                background-color: ${getColor("text.main")};
            }
        `,
    },
};
addToListModalStyles.newListInput = {
    cssOverrides: {
        formField: css`
            margin-top: 15px;
            label {
                color: ${getColor("text.main")};
            }
        `,
    },
};
addToListModalStyles.cancelButton = {
    variant: "secondary",
    css: css`
        margin-left: 10px;
        border-radius: 0px;
        padding: 10px 34px;
        background: ${getColor("secondary")};
        border: 2px solid ${getColor("primary")} !important;
        span[class^="TypographyStyle"] {
            color: ${getColor("primary")};
            font-size: 14px;
            line-height: ${TYPOGRAPHY.lineHeight.base};
        }
        &:hover {
            /* background: ${getColor("text.accent")}; */
            /* border: 2px solid  background: ${getColor("text.accent")}; */
            opacity: 0.3;
            background: none !important;
            /* span[class^="TypographyStyle"] {
                color: ${getColor("secondary")};
           
        } */
        }
    `,
};
addToListModalStyles.addButton = {
    css: css`
        margin-left: 10px;
        border-radius: 0;
        padding: 10px 34px;
        background: ${getColor("primary")};
        border: 2px solid ${getColor("primary")};

        span[class^="TypographyStyle"] {
            color: ${getColor("primary.contrast")};
            font-size: 14px;
            line-height: ${TYPOGRAPHY.lineHeight.base};
        }
        &:hover {
            background: ${getColor("text.accent")};
            /* border: 2px solid  background: ${getColor("text.accent")}; */
            span[class^="TypographyStyle"] {
                color: ${getColor("primary.contrast")};
            }
        }
    `,
};
